export default function NavigationButton({ url, text }) {
  return (
    <a className="navigation-button" href={url}>
      {text}
    </a>
  );
}
